import React from "react";
import "./Contact.css";
import backgroundImage from "../../assets/image 2.png"; // Use renamed image without space

function Contact() {
  return (
    <div className="contact-wrapper">
      <div
        className="contact-hero"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      ></div>

      <div className="contact-content">
        <h3 className="contact-title">ติดต่อเรา</h3>
        <div className="contact-info">
          <h3>Contact Info</h3>
          <p>
            2027/8 ซอยเจริญกรุง 77 ถนนเจริญกรุง วัดพระยาไกร เขตบางคอแหลม
            <br />
            กรุงเทพมหานคร 10520
            <br />
            Thailand
          </p>
          <p>📞 +66 92-256-8607</p>
          <p>📧 info@eiath.org</p>
          {/* <div className="social-icons">
            <span>🔗</span>
            <span>📷</span>
          </div> */}
        </div>
        <div className="contact-form">
          <h3>Contact us</h3>
          <form>
            <div className="form-row">
              <input type="text" placeholder="ชื่อ" />
              <input type="text" placeholder="นามสกุล" />
            </div>
            <div className="form-row">
              <input type="text" placeholder="เบอร์โทร" />
              <input type="email" placeholder="อีเมล" />
            </div>
            <textarea placeholder="รายละเอียด" />
            <button type="submit">ส่ง</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
